import type { FlowStepNode } from '@modules/reactFlow/adapters/V2ScreenAdapter';
import type { V2ScreenTypeConfig, V2SectionType } from '@modules/reactFlow/config/v2ScreenTypeConfig';

function hasAiAssetSlots(step: FlowStepNode): boolean {
  const aiAssets = (step as any).aiAssets;
  return !!aiAssets && typeof aiAssets === 'object' && Object.keys(aiAssets).length > 0;
}

export function getActiveV2EditorSections(
  config: Pick<V2ScreenTypeConfig, 'sections' | 'aiSections'>,
  mode: 'full' | 'ai',
  step: FlowStepNode,
): V2SectionType[] {
  const sections = mode === 'ai'
    ? (config.aiSections ?? config.sections)
    : config.sections;

  if (!hasAiAssetSlots(step) || sections.includes('aiAssets')) {
    return sections;
  }

  return [...sections, 'aiAssets'];
}
